import Box from '~/common/mui/Layout/Box';

type BoxProps = React.ComponentProps<typeof Box>;

const ModalHeader = ({ children, className, ...props }: Readonly<BoxProps>) => {
  return (
    <Box
      className={['mui-modal-header', className].filter(Boolean).join(' ')}
      {...props}
    >
      {children}
    </Box>
  );
};

export default ModalHeader;
